export default __webpack_public_path__ + "static/media/az_players_club_white_logo.753d10ba.png";